export default __webpack_public_path__ + "media/images/star-3ac5d487ff157adf1b626df6d8d27852.svg";